// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import { motion } from "framer-motion";
// import { FaCheckCircle, FaTimesCircle, FaClock } from "react-icons/fa";
// import { apiurl } from "../config/config";
// import Layout, { Container } from "../components/layout";

// const StatusIcon = ({ status }) => {
//   if (status === "success")
//     return <FaCheckCircle className="text-green-500" />;
//   if (status === "failed")
//     return <FaTimesCircle className="text-red-500" />;
//   return <FaClock className="text-yellow-500" />;
// };

// const StatusBadge = ({ status }) => {
//   const styles = {
//     success: "bg-green-100 text-green-700 border-green-200",
//     failed: "bg-red-100 text-red-700 border-red-200",
//     pending: "bg-yellow-100 text-yellow-700 border-yellow-200",
//   };

//   return (
//     <span
//       className={`px-3 py-1 text-xs rounded-full border ${
//         styles[status] || "bg-gray-100 text-gray-600"
//       }`}
//     >
//       {status}
//     </span>
//   );
// };

// const Card = ({ title, children }) => (
//   <motion.div
//     initial={{ opacity: 0, y: 20 }}
//     animate={{ opacity: 1, y: 0 }}
//     className="bg-white rounded-2xl shadow-sm border p-6 mb-6"
//   >
//     <h3 className="text-lg font-semibold mb-4 border-b pb-2">{title}</h3>
//     {children}
//   </motion.div>
// );

// const LeadDetails = () => {
//   const { leadObjId } = useParams();
//   const [lead, setLead] = useState(null);

//   useEffect(() => {
//     axios.get(`${apiurl}/api/lead/get/${leadObjId}`).then((res) => {
//       setLead(res.data.lead);
//     });
//   }, [leadObjId]);

//   if (!lead) return <div className="p-10">Loading...</div>;

//   return (
//     <Layout>
//       <Container overflow="overflow-scroll">
//         <div className="p-8 bg-gray-50 min-h-screen">

//           {/* HEADER */}
//           <div className="mb-8">
//             <h2 className="text-3xl font-bold text-gray-800">
//               {lead.fullName}
//             </h2>
//             <p className="text-gray-500">{lead.phone}</p>
//             <div className="mt-2">
//               <StatusBadge status={lead.status} />
//             </div>
//           </div>

//           {/* BASIC INFO */}
//           <Card title="Basic Information">
//             <div className="grid md:grid-cols-2 gap-4 text-sm">
//               <p><b>Email:</b> {lead.email || "—"}</p>
//               <p><b>Source:</b> {lead.source}</p>
//               <p><b>Landing Page:</b> {lead.landingPage}</p>
//               <p><b>IP Address:</b> {lead.ipAddress}</p>
//               <p><b>Country:</b> {lead.meta?.country}</p>
//               <p><b>Created At:</b> {new Date(lead.createdAt).toLocaleString()}</p>
//               <p><b>Updated At:</b> {new Date(lead.updatedAt).toLocaleString()}</p>
//               <p><b>Submission Date:</b> {new Date(lead.submissionDate).toLocaleString()}</p>
//             </div>
//           </Card>

//           {/* UTM DETAILS */}
//           <Card title="UTM Tracking">
//             <div className="grid md:grid-cols-2 gap-4 text-sm">
//               {Object.entries(lead.utm || {}).map(([key, value]) => (
//                 <p key={key}>
//                   <b>{key}:</b> {value || "—"}
//                 </p>
//               ))}
//             </div>
//           </Card>

//           {/* META DETAILS */}
//           <Card title="Meta Information">
//             <div className="text-xs bg-gray-100 p-4 rounded overflow-x-auto">
//               <pre>{JSON.stringify(lead.meta, null, 2)}</pre>
//             </div>
//           </Card>

//           {/* INTEGRATIONS */}
//           <Card title="Integrations">
//             {lead.integrations?.map((integration, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ delay: index * 0.1 }}
//                 className="border rounded-xl p-5 mb-6 bg-gray-50"
//               >
//                 <div className="flex justify-between items-center mb-3">
//                   <h4 className="text-md font-semibold capitalize flex items-center gap-2">
//                     <StatusIcon status={integration.status} />
//                     {integration.name}
//                   </h4>
//                   <StatusBadge status={integration.status} />
//                 </div>

//                 <div className="grid md:grid-cols-2 gap-4 text-sm mb-4">
//                   <p><b>Attempts:</b> {integration.attempts}</p>
//                   <p><b>Pushed At:</b> {integration.pushedAt ? new Date(integration.pushedAt).toLocaleString() : "—"}</p>
//                   <p><b>Last Attempt:</b> {integration.lastAttemptAt ? new Date(integration.lastAttemptAt).toLocaleString() : "—"}</p>
//                   {integration.errorMessage && (
//                     <p className="text-red-600"><b>Error:</b> {integration.errorMessage}</p>
//                   )}
//                 </div>

//                 {/* REQUEST */}
//                 <div className="mb-4">
//                   <h5 className="font-medium mb-2">Request Payload</h5>
//                   <div className="text-xs bg-gray-100 p-4 rounded overflow-x-auto">
//                     <pre>{JSON.stringify(integration.requestPayload, null, 2)}</pre>
//                   </div>
//                 </div>

//                 {/* RESPONSE */}
//                 <div>
//                   <h5 className="font-medium mb-2">Response Payload</h5>
//                   <div className="text-xs bg-gray-100 p-4 rounded overflow-x-auto">
//                     <pre>{JSON.stringify(integration.responsePayload, null, 2)}</pre>
//                   </div>
//                 </div>

//               </motion.div>
//             ))}
//           </Card>

//           {/* RAW LEAD OBJECT */}
//           <Card title="Complete Raw Lead Object">
//             <div className="text-xs bg-gray-100 p-4 rounded overflow-x-auto">
//               <pre>{JSON.stringify(lead, null, 2)}</pre>
//             </div>
//           </Card>

//         </div>
//       </Container>
//     </Layout>
//   );
// };

// export default LeadDetails;
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaCopy,
  FaRedo,
  FaFlag,
  FaEdit,
} from "react-icons/fa";
import { apiurl } from "../config/config";
import Layout, { Container } from "../components/layout";

const statuses = ["pending", "success", "failed"];

const StatusIcon = ({ status }) => {
  if (status === "success")
    return <FaCheckCircle className="text-green-500" />;
  if (status === "failed")
    return <FaTimesCircle className="text-red-500" />;
  return <FaClock className="text-yellow-500" />;
};

const StatusBadge = ({ status }) => {
  const styles = {
    success: "bg-green-100 text-green-700",
    failed: "bg-red-100 text-red-700",
    pending: "bg-yellow-100 text-yellow-700",
  };

  return (
    <span className={`px-3 py-1 text-xs rounded-full ${styles[status]}`}>
      {status}
    </span>
  );
};

const CollapsibleJSON = ({ title, data }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-4 border rounded-lg">
      <div
        onClick={() => setOpen(!open)}
        className="cursor-pointer p-3 bg-gray-100 font-medium flex justify-between"
      >
        {title}
        <span>{open ? "−" : "+"}</span>
      </div>

      <AnimatePresence>
        {open && (
          <motion.pre
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="p-4 text-xs bg-gray-50 overflow-x-auto"
          >
            {JSON.stringify(data, null, 2)}
          </motion.pre>
        )}
      </AnimatePresence>
    </div>
  );
};

const LeadDetails = () => {
  const { leadObjId } = useParams();
  const [lead, setLead] = useState(null);
  const [editModal, setEditModal] = useState(false);

  const fetchLead = () => {
    axios.get(`${apiurl}/api/lead/get/${leadObjId}`).then((res) => {
      setLead(res.data.lead);
    });
  };

  useEffect(() => {
    fetchLead();
  }, []);

  const updateStatus = async (status) => {
    await axios.patch(`${apiurl}/api/lead/update/${lead._id}`, { status });
    fetchLead();
  };

  const retryIntegration = async (name) => {
    await axios.post(`${apiurl}/api/lead/retry/${lead._id}`, { name });
    fetchLead();
  };

  const copy = (text) => {
    navigator.clipboard.writeText(text);
  };

  if (!lead) return <div className="p-10">Loading...</div>;

  const countryCode = lead.meta?.country?.toLowerCase();

  const facebook = lead.integrations?.find(i => i.name === "facebook");
  const fbEvent = facebook?.requestPayload?.data?.[0];

  return (
    <Layout>
      <Container overflow="overflow-scroll">
        <div className="p-8 bg-gray-50 min-h-screen">

          {/* HEADER */}
          <div className="flex justify-between items-start mb-6">
            <div>
              <h2 className="text-3xl font-bold flex items-center gap-3">
                {lead.fullName}
                {countryCode && (
                  <img
                    src={`https://flagcdn.com/24x18/${countryCode}.png`}
                    alt="flag"
                  />
                )}
              </h2>
              <p className="text-gray-500 flex items-center gap-2">
                {lead.phone}
                <FaCopy
                  className="cursor-pointer"
                  onClick={() => copy(lead.phone)}
                />
              </p>
              <div className="mt-2">
                <StatusBadge status={lead.status} />
              </div>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => setEditModal(true)}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg flex items-center gap-2"
              >
                <FaEdit /> Edit
              </button>
            </div>
          </div>

          {/* STATUS DROPDOWN */}
          <div className="mb-6">
            <label className="mr-3 font-medium">Update Status:</label>
            <select
              value={lead.status}
              onChange={(e) => updateStatus(e.target.value)}
              className="border rounded px-3 py-2"
            >
              {statuses.map((s) => (
                <option key={s}>{s}</option>
              ))}
            </select>
          </div>

          {/* BASIC INFO */}
          <div className="bg-white rounded-xl shadow p-6 mb-6">
            <h3 className="font-semibold mb-4">Basic Information</h3>
            <div className="grid md:grid-cols-2 gap-4 text-sm">
              <p><b>Email:</b> {lead.email || "—"}</p>
              <p><b>IP:</b> {lead.ipAddress}</p>
              <p><b>Source:</b> {lead.source}</p>
              <p><b>Landing Page:</b> {lead.landingPage}</p>
            </div>
          </div>

          {/* UTM */}
          <CollapsibleJSON title="UTM Tracking" data={lead.utm} />

          {/* META */}
          <CollapsibleJSON title="Meta Information" data={lead.meta} />

          {/* INTEGRATIONS TIMELINE */}
          <div className="bg-white rounded-xl shadow p-6 mb-6">
            <h3 className="font-semibold mb-4">Integration Timeline</h3>

            {lead.integrations?.map((intg, i) => (
              <div key={i} className="border-l-4 pl-4 mb-6 relative">
                <div className="absolute -left-3 top-1">
                  <StatusIcon status={intg.status} />
                </div>

                <div className="flex justify-between">
                  <h4 className="font-medium capitalize">{intg.name}</h4>
                  <StatusBadge status={intg.status} />
                </div>

                <p className="text-xs text-gray-500">
                  Attempts: {intg.attempts} | Last Attempt:{" "}
                  {new Date(intg.lastAttemptAt).toLocaleString()}
                </p>

                {intg.errorMessage && (
                  <p className="text-red-600 text-xs">
                    Error: {intg.errorMessage}
                  </p>
                )}

                <button
                  onClick={() => retryIntegration(intg.name)}
                  className="mt-2 text-blue-600 text-sm flex items-center gap-1"
                >
                  <FaRedo /> Retry
                </button>

                <CollapsibleJSON
                  title="Request Payload"
                  data={intg.requestPayload}
                />

                <CollapsibleJSON
                  title="Response Payload"
                  data={intg.responsePayload}
                />
              </div>
            ))}
          </div>

          {/* FACEBOOK DECODED VIEW */}
          {fbEvent && (
            <div className="bg-white rounded-xl shadow p-6 mb-6">
              <h3 className="font-semibold mb-4">Facebook Event (Decoded)</h3>

              <div className="grid md:grid-cols-2 gap-4 text-sm">
                <p><b>Event Name:</b> {fbEvent.event_name}</p>
                <p><b>Event Time:</b> {new Date(fbEvent.event_time * 1000).toLocaleString()}</p>
                <p><b>Content Name:</b> {fbEvent.custom_data?.content_name}</p>
                <p><b>IP:</b> {fbEvent.user_data?.client_ip_address}</p>
              </div>
            </div>
          )}

          {/* EDIT MODAL */}
          <AnimatePresence>
            {editModal && (
              <motion.div
                className="fixed inset-0 bg-black/40 flex justify-center items-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <motion.div
                  initial={{ scale: 0.8 }}
                  animate={{ scale: 1 }}
                  exit={{ scale: 0.8 }}
                  className="bg-white rounded-xl p-6 w-96"
                >
                  <h3 className="font-semibold mb-4">Edit Lead</h3>

                  <input
                    defaultValue={lead.fullName}
                    onChange={(e) =>
                      setLead({ ...lead, fullName: e.target.value })
                    }
                    className="border w-full p-2 mb-3 rounded"
                  />

                  <input
                    defaultValue={lead.phone}
                    onChange={(e) =>
                      setLead({ ...lead, phone: e.target.value })
                    }
                    className="border w-full p-2 mb-3 rounded"
                  />

                  <div className="flex justify-end gap-3">
                    <button
                      onClick={() => setEditModal(false)}
                      className="px-3 py-2 border rounded"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={async () => {
                        await axios.patch(
                          `${apiurl}/api/lead/update/${lead._id}`,
                          lead
                        );
                        setEditModal(false);
                        fetchLead();
                      }}
                      className="px-3 py-2 bg-blue-500 text-white rounded"
                    >
                      Save
                    </button>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

        </div>
      </Container>
    </Layout>
  );
};

export default LeadDetails;